import { useEffect, useState } from "react";
import { FeedbackApi } from "../api";
import { FeedbackData, FEEDBACK_STATUS, FeedbackStatus } from "../../../types";

// null covers both "hasn't loaded yet" and "not an admin" — either way the
// panel stays invisible rather than flashing an error at ordinary users.
export const AdminFeedbackPanel = () => {
  const [feedback, setFeedback] = useState<FeedbackData[] | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    FeedbackApi.getLog().then((result) => {
      if (result.success && result.data) {
        setFeedback(result.data.feedback);
      }
    });
  }, []);

  const setStatus = async (item: FeedbackData, status: FeedbackStatus) => {
    setFeedback(
      (f) => f?.map((existing) => (existing.id === item.id ? { ...existing, status } : existing)) ?? null,
    );
    await FeedbackApi.update({
      id: item.id,
      createdAt: item.createdAt,
      userId: item.userId,
      status,
    });
  };

  if (feedback === null) return null;

  return (
    <section className="pt-4 border-t">
      <button
        onClick={() => setOpen((o) => !o)}
        className="text-sm font-semibold text-neutral-500"
      >
        Feedback log ({feedback.filter((f) => f.status === FEEDBACK_STATUS.NEW).length} new)
      </button>
      {open && (
        <ul className="space-y-1 mt-2">
          {feedback.map((item) => (
            <li key={item.id} className="bg-white border rounded px-3 py-2 text-sm space-y-1">
              <div className="flex items-start justify-between gap-2">
                <span>{item.text}</span>
                <span className="text-xs text-neutral-400 capitalize whitespace-nowrap">
                  {item.status}
                </span>
              </div>
              {item.page && <p className="text-xs text-neutral-400">{item.page}</p>}
              {item.resolutionNote && (
                <p className="text-xs text-neutral-500 italic">{item.resolutionNote}</p>
              )}
              {item.branch && (
                <p className="text-xs text-neutral-400 font-mono">branch: {item.branch}</p>
              )}
              <div className="flex gap-2 text-xs">
                {Object.values(FEEDBACK_STATUS).map((status) => (
                  <button
                    key={status}
                    onClick={() => setStatus(item, status)}
                    className={`capitalize ${
                      item.status === status ? "font-semibold" : "text-neutral-400"
                    }`}
                  >
                    {status}
                  </button>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
